<script setup>
import ImoSkeleton from './ImoSkeleton.vue'
import ImoSkeletonText from './ImoSkeletonText.vue'

defineProps({
  lines: {
    type: Number,
    default: 3,
  },
})
</script>

<template>
  <div
    class="border-neutral-30 flex w-full flex-col gap-4 overflow-hidden rounded-2xl border bg-white p-5"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span class="sr-only">Carregando…</span>
    <div class="flex items-center gap-3">
      <ImoSkeleton circle width="2.5rem" />
      <ImoSkeleton width="40%" height="1rem" />
    </div>
    <ImoSkeletonText :lines="lines" />
  </div>
</template>
